export default "__VITE_ASSET__CynfMi_3__"